/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click a swatch to copy its hex code.`)
};

const es_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic en una muestra para copiar su código hexadecimal.`)
};

const de_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicke auf ein Farbfeld, um dessen Hex-Code zu kopieren.`)
};

const nl_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik op een kleurvlak om de hexcode te kopiëren.`)
};

const fr_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez sur un échantillon pour copier son code hexadécimal.`)
};

const it_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca su un campione per copiarne il codice esadecimale.`)
};

const pt_br2_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique em uma amostra para copiar o código hex.`)
};

const pt_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique numa amostra para copiar o seu código hex.`)
};

const ja_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スウォッチをクリックすると16進数コードをコピーできます。`)
};

const zh_cp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击色块即可复制其十六进制代码。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_ex3", locale)
	if (locale === "en") return en_cp_ex3(inputs)
	if (locale === "es") return es_cp_ex3(inputs)
	if (locale === "de") return de_cp_ex3(inputs)
	if (locale === "nl") return nl_cp_ex3(inputs)
	if (locale === "fr") return fr_cp_ex3(inputs)
	if (locale === "it") return it_cp_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_cp_ex3(inputs)
	if (locale === "pt") return pt_cp_ex3(inputs)
	if (locale === "ja") return ja_cp_ex3(inputs)
	return zh_cp_ex3(inputs)
};